import { Button, Card, Col, Form, Input, Row, Typography } from 'antd';
import { openNotificationWithIcon } from 'app/components/PopupNotification';
import { clearLocalStorage, ValidationError, ValidationSchema } from 'app/constants';
import { checkUserInvitationAPI, signUpAPI } from 'app/services/api/auth';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import PhoneInput from 'react-phone-input-2';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setLoginScreen, setSelectProduct } from '../LoginPage/auth.slice';
import './SignUp.scss';

const { Text, Title } = Typography;

export function SignUpPage() {
  const location = useLocation();
  const email = new URLSearchParams(location.search).get('email');
  const token = new URLSearchParams(location.search).get('token');
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [isUserInvitation, setIsUserInvitation] = React.useState<boolean>(true);
  const [contactNumber, setContactNumber] = React.useState<any>();
  const history = useHistory();
  const [dialCode, setDialCode] = React.useState<any>('+61'); // default là Úc
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [submittable, setSubmittable] = React.useState<boolean>(true);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const onFinish = async (value: any) => {
    setLoading(true);

    try {
      await form
        .validateFields()
        .then(async value => {
          const res: any = await signUpAPI({
            ...value,
            invitationCode: token,
          });

          openNotificationWithIcon('success', res.message);
          // localStorage.clear();
          clearLocalStorage();
          sessionStorage.clear();
          dispatch(setLoginScreen(1));
          dispatch(setSelectProduct(undefined));
          window.location.href = '/login';
          setLoading(false);
        })
        .catch(error => {
          openNotificationWithIcon('error', error.message);
          setLoading(false);
        });
    } catch (error: any) {}
  };

  const checkUserInvitation = async (email: string, token: string) => {
    try {
      const res = await checkUserInvitationAPI(email, token);
      setIsUserInvitation(true);
    } catch (error) {
      setIsUserInvitation(false);
    }
  };

  const handleChange = (val: string, data: any) => {
    const newDialCode = `+${data?.dialCode}`;
    setDialCode(newDialCode);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const pos = inputRef.current?.selectionStart || 0;
    if (pos <= dialCode.length && (e.key === 'Backspace' || e.key === 'Delete')) {
      e.preventDefault();
    }
  };

  React.useEffect(() => {
    if (email && token) {
      checkUserInvitation(email, token);
    }
  }, [email, token]);

  React.useEffect(() => {
    if (values?.firstName?.trim().length > 50 || values?.lastName?.trim().length > 50) {
      return setSubmittable(true);
    }

    if (values?.firstName || values?.lastName) {
      const hasEmptyRequired = Object.entries(form.getFieldsValue()).some(
        ([key, value]) => value === undefined || (typeof value === 'string' && value.trim() === ''),
      );
      setSubmittable(hasEmptyRequired);
    }
  }, [values, form]);

  React.useEffect(() => {
    const flagIcon = document.querySelector('.sign-up-phone-input .selected-flag .flag');
    flagIcon?.setAttribute('name', 'phone-input-flag-icon');
  }, [dialCode]);

  return isUserInvitation ? (
    <div className="sign-up">
      <>
        <Helmet>
          <title>Sign Up</title>
        </Helmet>

        <Row className="container" justify={'center'} align={'middle'}>
          <Col className="content" sm={18} md={18} lg={12} xs={18}>
            <Card className="card">
              <Row justify={'center'} className="cardrow">
                <Col span={24} className="col_imgHeader">
                  <img src="/Img/Header.png" className="img_header" alt="" />
                </Col>
                <Col sm={16} lg={16} md={16} xs={16} style={{ alignContent: 'center' }}>
                  <Title className="text_title">Sign Up</Title>
                  <Text type="secondary" className="text_header">
                    Please enter your information to create your account
                  </Text>
                  <Form
                    layout="vertical"
                    initialValues={{ remember: true, email: email }}
                    onFinish={onFinish}
                    form={form}
                  >
                    <Form.Item
                      htmlFor="sign-up__email__input"
                      label={<span className="label_form">Email</span>}
                      name="email"
                    >
                      <Input
                        disabled
                        id="sign-up__email__input"
                        className="input_username"
                        placeholder="Enter your username"
                      />
                    </Form.Item>
                    <Form.Item
                      htmlFor="sign-up__username__input"
                      label={<span className="label_form">Username</span>}
                      name="email"
                    >
                      <Input
                        disabled
                        id="sign-up__username__input"
                        className="input_username"
                        placeholder="Enter your username"
                      />
                    </Form.Item>

                    <Row gutter={[12, 0]} style={{ marginBottom: -15 }}>
                      <Col span={12}>
                        <Form.Item
                          label="First Name"
                          name="firstName"
                          htmlFor="sign-up__first-name__input"
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter First Name',
                            },
                            {
                              max: values?.firstName?.trim().length > 50 ? 50 : undefined,
                              message: '',
                            },
                          ]}
                        >
                          <Input
                            id="sign-up__first-name__input"
                            className="input_username"
                            placeholder="Enter First Name"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Last Name"
                          name="lastName"
                          htmlFor="sign-up__last-name__input"
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter Last Name',
                            },
                            {
                              max: values?.firstName?.trim().length > 50 ? 50 : undefined,
                              message: '',
                            },
                          ]}
                        >
                          <Input
                            id="sign-up__last-name__input"
                            className="input_username"
                            placeholder="Enter Last Name"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[12, 0]}>
                      <Col
                        span={12}
                        className={`mb-10 `}
                        style={{
                          justifyContent: 'flex-end',
                          color: values?.firstName?.trim().length > 50 ? 'red' : '',
                        }}
                      >
                        <Row justify="end">{values?.firstName?.trim().length ?? 0}/50</Row>
                      </Col>
                      <Col
                        span={12}
                        className={`mb-10 `}
                        style={{
                          justifyContent: 'flex-end',
                          color: values?.lastName?.trim().length > 50 ? 'red' : '',
                        }}
                      >
                        <Row justify="end">{values?.lastName?.trim().length ?? 0}/50</Row>{' '}
                      </Col>
                    </Row>

                    <Col span={24}>
                      <Form.Item
                        label="Contact Number"
                        name="contactNumber"
                        htmlFor="signup__contact-number"
                        required={true}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator() {
                              if (!ValidationSchema.phoneNumber.test(getFieldValue('contactNumber'))) {
                                return Promise.reject(new Error(ValidationError.phoneNumber));
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        {/* <PhoneInput country={'au'} placeholder="Enter Contact Number" inputClass="contact-number" />  */}
                        <PhoneInput
                          country={'au'}
                          onChange={handleChange}
                          containerClass="sign-up-phone-input"
                          inputProps={{
                            id: 'signup__contact-number',
                            ref: inputRef,
                            onKeyDown: handleKeyDown,
                            required: true,
                            name: 'phone',
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="password"
                        label="Enter Password"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter Password',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || ValidationSchema.checkPassSpecial.test(getFieldValue('password'))) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error(ValidationError.password));
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="At least 8 characters, upper and lower cases, number and special characters" />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        dependencies={['password']}
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm Password',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('The new password that you entered does not match!'));
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="At least 8 characters, upper and lower cases, number and special characters" />
                      </Form.Item>
                    </Col>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        id="login__signin__button"
                        className="login_button mt-20"
                        loading={loading}
                        disabled={submittable}
                      >
                        Sign Up
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
                <Col span={24} className="card_footer">
                  <img src="/Img/Footer.png" className="img_footer" alt="" />
                </Col>
                <Text className="text_footer">
                  © Copyright PinnacleQM 2014 - {new Date().getFullYear()}. All Rights Reserved
                </Text>
              </Row>
            </Card>
          </Col>
        </Row>
      </>
    </div>
  ) : (
    history.push('/login')
  );
}
